export function validateGif(file) {
  if (file.type) {
    if (file.type === 'image/gif') {
      return true;
    }
  } else if (file.name.toLowerCase().endsWith('gif')) {
    // Edge file.type 처리
    return true;
  }
  return false;
}
